module.exports = __webpack_public_path__ + "img/logo2a.ab3306e7.png";